export const TRIGGER_API_FETCH = 'TRIGGER_API_FETCH';
export const FETCH_WISHES_SUCCESS = 'FETCH_WISHES_SUCCESS';
export const FETCH_WISHES_FAILURE = 'FETCH_WISHES_FAILURE';

export const triggerApiFetch = () => ({
  type: TRIGGER_API_FETCH,
});

export const fetchWishesSuccess = () => ({ 
    type: FETCH_WISHES_SUCCESS,
});

export const fetchWishesFailure = (error) => ({ 
    type: FETCH_WISHES_FAILURE, payload: error 
});
